export const WORK_ORDER = "WORK_ORDER";
export const ARCHIVED_WORK_ORDER = "ARCHIVED_WORK_ORDER";
export const LINK_WORK_ORDER = "LINK_WORK_ORDER";
export const WORK_ORDER_SCHEDULER = "WORK_ORDER_SCHEDULER";
export const MY_WORK_ORDER = "MY_WORK_ORDER";
export const SUPPORT_TICKET = "SUPPORT_TICKET";
export const MACHINES = "MACHINES";
export const MACHINES_FACILITY = "MACHINES_FACILITY";
export const MACHINES_TEAM = "MACHINES_TEAM";
export const FACILITES = "FACILITES";
export const KNOWLEDGE_BASE = "KNOWLEDGE_BASE";
export const PME = "PME";
export const ASSET_TEMPLATE = "ASSET_TEMPLATE";
export const CONNECTIONS = "CONNECTIONS";
export const INVENTORY = "INVENTORY";
export const PARTS = "PARTS";
export const CONTACTS = "CONTACTS";
export const FINANCE_QUOTES = "FINANCE_QUOTES";
export const FINANCE_INVOICES = "FINANCE_INVOICES";
